import axios from "axios";
import Cookies from "universal-cookie";

export async function Categories() {
    try {
        const response = await axios.get('https://expendedora.online/products/categories');
        return response.data;
    } catch (error) {
        console.error('Error al obtener las categorías:', error);
        return null;
    }
}

export async function getItemsByMachine(idmachine) {
    try {
        const url = `https://expendedora.online/products/machine/${idmachine}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('Error al obtener los items:', error);
        return null;
    }
}

export async function getMachineData(id) {
    try {
        const response = await axios.get(`https://expendedora.online/machine/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener la maquina:', error);
        return null;
    }
}

export async function setTransaction(body) {
    try {
        const response = await axios.post(`https://expendedora.online/transactions/new`, body);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function rollbackTransaction(qr_id) {
    try {
        const response = await axios.put(`https://expendedora.online/transactions/rollback/${qr_id}`);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getTransactionStatus(qr_id) {
    try {
        const response = await axios.get(`https://expendedora.online/transactions/status/${qr_id}`);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getMachines() {
    try {
        const response = await axios.get(`https://expendedora.online/machines`);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getProducts() {
    try {
        const response = await axios.get(`https://expendedora.online/products`);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function Authentication(body) {
    try {
        const response = await axios.post(`https://expendedora.online/auth`, body);
        if (response.status === 200) {
            const cookie = new Cookies()
            cookie.set('userdata', response.data);
            return response.data;
        } else
            return false;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function Products_Activated(body) {
    try {
        const response = await axios.post(`https://expendedora.online/products/activated`, body);
        return response.status
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function ParentsPosition(idmachine) {
    try {
        const response = await axios.get(`https://expendedora.online/machines/parents/${idmachine}`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getStockbyMachine(idmachine) {
    try {
        const response = await axios.get(`https://expendedora.online/stock/machine/${idmachine}`);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getStockbyProduct(idmachine, idproduct) {
    try {
        const response = await axios.get(`https://expendedora.online/stock/machine/${idmachine}/${idproduct}`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function getUnusedPositions(idmachine) {
    try {
        const response = await axios.get(`https://expendedora.online/positions/unused/${idmachine}`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function SaveUser(data) {
    try {

        const body = {
            token: "",
            cellphonenumber: data.cellphonenumber,
            dni: data.dni,
            email: data.email,
            firstname: data.firstname,
            iduser: data.iduser === undefined ? 0 : data.iduser,
            role: parseInt(data.role),
            surname: data.surname,
            username: data.username,
            password: data.password === undefined ? '' : data.password
        }
        const response = await axios.post(`https://expendedora.online/user`, body);
        return response.status
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function getUnassignedStock(body) {
    try {
        const response = await axios.post(`https://expendedora.online/stock/unassigned`, body);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function createMachine(body) {
    try {
        const response = await axios.post(`https://expendedora.online/machine/save`, body);
        return response.status;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function createProduct(body) {
    try {
        const response = await axios.post(`https://expendedora.online/products/save`, body);
        return response.status;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getStockList() {
    try {
        const response = await axios.get(`https://expendedora.online/stock`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getDeposits() {
    try {
        const response = await axios.get(`https://expendedora.online/deposits`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function SaveStock(body) {
    try {
        const response = await axios.post(`https://expendedora.online/stock/save`, body);
        return response.data;
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getRepositors() {
    try {
        const response = await axios.get(`https://expendedora.online/repositors`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}

export async function getTransactions() {
    try {
        const response = await axios.get(`https://expendedora.online/transactions`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function getDetailsTransactions(idtransaction) {
    try {
        const response = await axios.get(`https://expendedora.online/transactions/${idtransaction}`);
        return response.data
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}


export async function setStatusTransaction(idtransaction, status, type) {
    try {
        const response = await axios.post("https://expendedora.online/transactions/status/update", {
            status: status,
            idtransaction: idtransaction,
            type: type
        });
        return response.status
    } catch (error) {
        console.error('Error en generar transaccion: ', error);
        return null;
    }
}